import './english';
import './japanese';
import { getLanguage } from '../helpers/url';
function getCurrentLanguage() {
    let currentLanguage = getLanguage();
    // let languageFiles = {en: english, ja: japanese};
    const translations = window['translations']['body'] || null;
    if (!translations)
        return;
    const selectedLangTranslations = {};
    for (const key in translations) {
        selectedLangTranslations[key] = translations[key][currentLanguage] || translations[key]['en'];
    }
    return selectedLangTranslations;
}
export default getCurrentLanguage();
